import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EnglishArabicDTO, MultiLingualHtmlEditorOptions, MultiLingualTextBoxOptions } from 'bbsf-controls';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { EmailHeaderAndFooterTemplate } from '../../shared/models/NotificationsModels/EmailHeaderAndFooterTemplate';
import { EmailHeaderAndFooterTemplateService } from '../../shared/Services/EmailHeaderAndFooterTemplateService.Service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-edit',
  templateUrl: './edit.component.html'
})
export class EditComponent implements OnInit {

  //Add Model Controls
  //SubheaderTitle = this.getResourceValue('EditMasterLayout');
  //ShowToolbar = false;
  //ShowbreadCrumb = false;
  EditForm = new FormGroup({});
  TemplateId: number
  MultiLingualName:MultiLingualTextBoxOptions
  MultiLingualHtmlHeadTagAttributes:MultiLingualTextBoxOptions
  MultiLingualHeader:MultiLingualHtmlEditorOptions
  MultiLingualFooter:MultiLingualHtmlEditorOptions
  MultiLingualHtmlHeadSection:MultiLingualHtmlEditorOptions
  IsAEditFormLoaded: boolean;
  language:string=""
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;

  constructor(private pageInfoService:PageInfoService, private authService:AuthService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private emailHeaderAndFooterTemplateService: EmailHeaderAndFooterTemplateService, private activatedRoute: ActivatedRoute,private router :Router) {
    this.activatedRoute.params.subscribe(params => {
      this.TemplateId = params['id'];     
      });
  }

  async ngOnInit(): Promise<void> {
    PageInfoService.PageTitle=""
    PageInfoService.PageBreadcrumbs=[
    ];

    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
       this.IsAEditFormLoaded=false;
    this.loadEditForm();
  }

 
 
  loadEditForm() {
    this.emailHeaderAndFooterTemplateService.GetEmailHeaderAndFooterTemplateById(this.TemplateId).subscribe((result) => {
      var EditObject= result as any  ;
      
      let Name=new EnglishArabicDTO();
      Name.Arabic=EditObject.name.arabic;
      Name.English=EditObject.name.english;
  
      this.MultiLingualName = new MultiLingualTextBoxOptions();
      this.MultiLingualName.Name = "Name";
      this.MultiLingualName.ArabicLabelKey = "NameInArabic";
      this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
      this.MultiLingualName.IsRequired = true;
      this.MultiLingualName.Value = Name;

      let HtmlHeadTagAttributes=new EnglishArabicDTO();
      HtmlHeadTagAttributes.Arabic=EditObject.headTagAttributes.arabic;
      HtmlHeadTagAttributes.English=EditObject.headTagAttributes.english;
  
      this.MultiLingualHtmlHeadTagAttributes = new MultiLingualTextBoxOptions();
      this.MultiLingualHtmlHeadTagAttributes.Name = "HtmlHeadTagAttributes";
      this.MultiLingualHtmlHeadTagAttributes.ArabicLabelKey =  "HtmlHeadTagAttributesInArabic";
      this.MultiLingualHtmlHeadTagAttributes.EnglishLabelKey = "HtmlHeadTagAttributesInEnglish";
      this.MultiLingualHtmlHeadTagAttributes.IsRequired = true;
      this.MultiLingualHtmlHeadTagAttributes.Value = HtmlHeadTagAttributes;
  
    
      let Header=new EnglishArabicDTO();
      Header.Arabic=EditObject.header.arabic;
      Header.English=EditObject.header.english;
  
      this.MultiLingualHeader = new MultiLingualHtmlEditorOptions();
      this.MultiLingualHeader.Name = "Header";
      this.MultiLingualHeader.ArabicLabelKey =  "HeaderInArabic";
      this.MultiLingualHeader.EnglishLabelKey = "HeaderInEnglish";
      this.MultiLingualHeader.IsRequired = true;
      this.MultiLingualHeader.Value = Header;
  

      let Footer=new EnglishArabicDTO();
      Footer.Arabic=EditObject.footer.arabic;
      Footer.English=EditObject.footer.english;
  
      this.MultiLingualFooter = new MultiLingualHtmlEditorOptions();
      this.MultiLingualFooter.Name = "Footer";
      this.MultiLingualFooter.ArabicLabelKey =  "FooterInArabic";
      this.MultiLingualFooter.EnglishLabelKey = "FooterInEnglish";
      this.MultiLingualFooter.IsRequired = true;
      this.MultiLingualFooter.Value = Footer;
  
    

      let HtmlHeadSection=new EnglishArabicDTO();
      HtmlHeadSection.Arabic=EditObject.headSection.arabic;
      HtmlHeadSection.English=EditObject.headSection.english;
  
      this.MultiLingualHtmlHeadSection = new MultiLingualHtmlEditorOptions();
      this.MultiLingualHtmlHeadSection.Name = "HtmlHeadSection";
      this.MultiLingualHtmlHeadSection.ArabicLabelKey =  "HTMLHeadSectionInArabic";
      this.MultiLingualHtmlHeadSection.EnglishLabelKey = "HTMLHeadSectionInEnglish";
      this.MultiLingualHtmlHeadSection.IsRequired = true;
      this.MultiLingualHtmlHeadSection.Value = Footer;
 
  
       setTimeout(() => {
        this.IsAEditFormLoaded = true;
      }, 10);
       

    });
    }

    editHeaderTemplate(){
      if (this.EditForm.invalid) {
        return;
      }
      else {
        let ResultModel = this.EditForm.value;
        let EmailHeaderAndFooterTemplateModel = new EmailHeaderAndFooterTemplate();
        EmailHeaderAndFooterTemplateModel.ID = Number(this.TemplateId);
        EmailHeaderAndFooterTemplateModel.Name.English = ResultModel.Name.EnglishValue
        EmailHeaderAndFooterTemplateModel.Name.Arabic = ResultModel.Name.ArabicValue
        EmailHeaderAndFooterTemplateModel.Header.English = ResultModel.Header.EnglishHtmlEditorValue
        EmailHeaderAndFooterTemplateModel.Header.Arabic = ResultModel.Header.ArabicHtmlEditorValue
        EmailHeaderAndFooterTemplateModel.Footer.English = ResultModel.Footer.EnglishHtmlEditorValue
        EmailHeaderAndFooterTemplateModel.Footer.Arabic = ResultModel.Footer.ArabicHtmlEditorValue
        EmailHeaderAndFooterTemplateModel.HeadSection.English = ResultModel.HtmlHeadSection.EnglishHtmlEditorValue
        EmailHeaderAndFooterTemplateModel.HeadSection.Arabic = ResultModel.HtmlHeadSection.ArabicHtmlEditorValue
        EmailHeaderAndFooterTemplateModel.HeadTagAttributes.English = ResultModel.HtmlHeadTagAttributes.EnglishValue
        EmailHeaderAndFooterTemplateModel.HeadTagAttributes.Arabic = ResultModel.HtmlHeadTagAttributes.ArabicValue



        this.emailHeaderAndFooterTemplateService.EditEmailHeaderAndFooterTemplate(EmailHeaderAndFooterTemplateModel).subscribe((result) => {
          this.EditForm.reset()
          this.close()
        }, (error) => {
        
        })
      }
    }
    close(){
      this.router.navigate(['/Admin/Notifications/MasterLayouts']);
    }
  
}
